import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const URL_PARAM_DEVICE_ID = 'deviceId';
export const URL_PARAM_MINIMIZED = 'minimized';

export const useDeviceDrawerActions = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openDeviceDrawer = useCallback(
    (deviceId: string, minimized = false) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set(URL_PARAM_DEVICE_ID, deviceId);
      if (minimized) {
        newSearchParams.set(URL_PARAM_MINIMIZED, 'true');
      } else {
        newSearchParams.delete(URL_PARAM_MINIMIZED);
      }
      setSearchParams(newSearchParams, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  const closeDeviceDrawer = useCallback(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(URL_PARAM_DEVICE_ID);
    newSearchParams.delete(URL_PARAM_MINIMIZED);
    setSearchParams(newSearchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  const setMinimized = useCallback(
    (minimized: boolean) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (minimized) {
        newSearchParams.set(URL_PARAM_MINIMIZED, 'true');
      } else {
        newSearchParams.delete(URL_PARAM_MINIMIZED);
      }
      setSearchParams(newSearchParams, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return {
    openDeviceDrawer,
    closeDeviceDrawer,
    setMinimized,
  };
};
